import { Sparkles } from 'lucide-react'
import { useI18n } from '../../i18n'
import { useDefendSphereAiOptional } from './DefendSphereAiProvider'
import './defendsphere-ai.css'

export type DefendSphereAiLauncherProps = {
  /** sidebar trailing-edge vs mobile header placement */
  placement?: 'sidebar' | 'mobile-header'
}

export function DefendSphereAiLauncher({ placement = 'sidebar' }: DefendSphereAiLauncherProps) {
  const ai = useDefendSphereAiOptional()
  const { t } = useI18n()

  if (!ai?.enabled) return null

  const label = t('complianceCenterUi.defendSphereAi.launcherLabel', 'DefendSphere AI')
  const open = ai.mode !== 'closed'

  return (
    <button
      type="button"
      className={`ds-ai-launcher ds-ai-launcher--${placement} ${open ? 'is-open' : ''}`}
      aria-label={label}
      aria-expanded={open}
      aria-controls="ds-ai-panel"
      title={label}
      onClick={() => {
        if (ai.mode === 'closed') ai.openPanel()
        else if (ai.mode === 'workspace') ai.collapseToPanel()
        else ai.close()
      }}
    >
      <Sparkles className="ds-ai-launcher__icon" aria-hidden />
      <span className="ds-ai-launcher__label">{label}</span>
    </button>
  )
}
